import React, { useMemo } from 'react'

import { type MonthlyDistribution } from './faker/utils'
import { useLayerApiUrl } from './ImportDataContext'
import {
  type BusinessIndustry,
  createCustomTransactions,
  type CustomAccount,
  type CustomTransactionParams,
  getExpenseCustomTransactions,
  validateCustomTransactions,
} from './importDummyDataHelpers'
import { ImportForm } from './ImportForm'
import { type ImportStepDef } from './useImportForm'

export interface ImportBankTransactionsProps {
  demoName: string
  businessId: string
  industry: BusinessIndustry
  businessAccessToken: string
  defaultCustomAccount: CustomAccount
  dist?: MonthlyDistribution
}

const buildBankTransactionSteps = (
  businessId: string,
  businessAccessToken: string,
  customAccountId: string,
  layerApiUrl: string,
) => (transactions: CustomTransactionParams[]): ImportStepDef[] => [
  {
    label: 'Creating bank transactions',
    run: async () => {
      await createCustomTransactions(
        businessId,
        businessAccessToken,
        customAccountId,
        transactions,
        layerApiUrl,
      )
    },
  },
]

export const ImportBankTransactions = ({
  demoName,
  businessId,
  industry,
  businessAccessToken,
  defaultCustomAccount,
  dist,
}: ImportBankTransactionsProps) => {
  const layerApiUrl = useLayerApiUrl()

  const getSteps = useMemo(
    () => buildBankTransactionSteps(businessId, businessAccessToken, defaultCustomAccount.id, layerApiUrl),
    [businessId, businessAccessToken, defaultCustomAccount.id, layerApiUrl],
  )

  return (
    <ImportForm
      title='Bank Transactions'
      defaultCustomAccount={defaultCustomAccount}
      getInitialData={() => getExpenseCustomTransactions(demoName, industry, dist)}
      validateData={validateCustomTransactions}
      getSteps={getSteps}
      dependencies={[demoName, industry, dist]}
    />
  )
}
